"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMealSlides = void 0;
var meal_data_1 = require("./meal-data");
function buildMealSlideItem(item) {
    return "\n    <li class=\"meal_slide_list-item swiper-slide\">\n      <div class=\"meal_slide_list-item_text\">\n        <span>".concat(item.text, "</span>\n      </div>\n      <div class=\"meal_slide_list-item_img\">\n        <img src=\"").concat(item.src, "\" width=\"600\" height=\"500\" alt=\"").concat(item.alt, "\" loading=\"lazy\" />\n      </div>\n      <div class=\"meal_slide_list-item_bg\"></div>\n    </li>\n  ");
}
function renderMealSlides() {
    var list = document.getElementById('js-mealSlideList');
    if (!list)
        return;
    list.innerHTML = meal_data_1.mealSlideData.map(buildMealSlideItem).join('');
}
exports.renderMealSlides = renderMealSlides;
